import React from "react";
import { useParams, Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import CategorySlider from "../../../CategorySlider";


/* ================= MADHYA PRADESH CITY DATA ================= */

const madhyaPradeshCities = [
  { slug: "bhopal", city: "Bhopal", state: "Madhya Pradesh" },
  { slug: "indore", city: "Indore", state: "Madhya Pradesh" },
  { slug: "jabalpur", city: "Jabalpur", state: "Madhya Pradesh" },
  { slug: "gwalior", city: "Gwalior", state: "Madhya Pradesh" },
  { slug: "ujjain", city: "Ujjain", state: "Madhya Pradesh" }
];

const MadhyaPradesh = () => {
  const { city } = useParams();

  /* ================= STATE PAGE ================= */
  if (!city) {
    return (
      <>
        <Helmet>
          <title>
            Sex Toys Delivery in Madhya Pradesh | Discreet Adult Store Online
          </title>
          <meta
            name="description"
            content="Buy sex toys online in Madhya Pradesh with 100% discreet delivery. Trusted adult store delivering to Bhopal, Indore, Jabalpur, Gwalior, Ujjain & more."
          />
          <link
            rel="canonical"
            href="https://lushdesire.in/sex-toys-delivery/madhya-pradesh"
          />
        </Helmet>

        <div
          style={{
            marginTop: "90px",
            padding: "25px",
            backgroundColor: "#FFF5F5",
            minHeight: "90vh",
            lineHeight: "1.8"
          }}
        >
          <h1>Sex Toys Delivery in Madhya Pradesh</h1>

          <p>
            Buy premium <strong>sex toys in Madhya Pradesh</strong> with fast,
            safe, and <strong>100% discreet delivery</strong>. LushDesire is a
            trusted Indian adult wellness store offering high-quality pleasure
            products for men, women, and couples across MP.
          </p>

          <h2>Cities We Serve in Madhya Pradesh</h2>

          <ul>
            {madhyaPradeshCities.map((c) => (
              <li key={c.slug}>
                <Link to={`/sex-toys-delivery/madhya-pradesh/${c.slug}`}>
                  Sex Toys in {c.city}
                </Link>
              </li>
            ))}
          </ul>

          <h3>Why Buy Sex Toys Online from LushDesire?</h3>
          <ul>
            <li>✔ Genuine & body-safe adult products</li>
            <li>✔ Plain, discreet packaging</li>
            <li>✔ Cash on Delivery available</li>
            <li>✔ Fast delivery across Madhya Pradesh</li>
          </ul>

          <p>
            Shop confidently and enjoy private, secure shopping from one of
            India’s most trusted adult stores.
          </p>
        </div>
      </>
    );
  }

  /* ================= CITY PAGE ================= */
  const cityData = madhyaPradeshCities.find((c) => c.slug === city);

  if (!cityData) {
    return (
      <div style={{ marginTop: "120px", padding: "30px" }}>
        <h2>City not found</h2>
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>
          Sex Toys in {cityData.city} | Discreet Delivery in Madhya Pradesh
        </title>
        <meta
          name="description"
          content={`Buy sex toys in ${cityData.city} with fast & discreet delivery. Premium adult toys and couples wellness products available in ${cityData.city}, Madhya Pradesh.`}
        />
        <link
          rel="canonical"
          href={`https://lushdesire.in/sex-toys-delivery/madhya-pradesh/${cityData.slug}`}
        />
      </Helmet>
      <CategorySlider />


      <div
        style={{

          padding: "25px",
          backgroundColor: "#FFF5F5",
          minHeight: "90vh",
          lineHeight: "1.8"
        }}
      >
        <h1>Sex Toys in {cityData.city} – Discreet Home Delivery</h1>

        <p>
          Looking to buy <strong>sex toys in {cityData.city}</strong>? LushDesire
          offers premium adult wellness products with complete privacy and fast
          delivery across {cityData.city} and nearby areas of Madhya Pradesh.
        </p>

        <h2>Buy Sex Toys Online in {cityData.city}</h2>
        <p>
          Buying sex toys online in {cityData.city} is now safe, private, and
          convenient. Our collection is curated to help individuals and couples
          explore pleasure, intimacy, and confidence comfortably.
        </p>

        <h3>Popular Adult Toys Available</h3>
        <ul>
          <li>✔ Vibrators & Body Massagers</li>
          <li>✔ Dildos & Realistic Pleasure Toys</li>
          <li>✔ Couples Intimacy Products</li>
          <li>✔ Male & Female Wellness Toys</li>
        </ul>

        <h3>Why Choose LushDesire in {cityData.city}?</h3>
        <ul>
          <li>✔ 100% Discreet Packaging</li>
          <li>✔ Fast Local Delivery</li>
          <li>✔ Cash on Delivery Available</li>
          <li>✔ Trusted Indian Adult Store</li>
        </ul>

        <h4>Discreet Sex Toys Delivery in {cityData.city}</h4>
        <p>
          All orders are shipped in plain packaging with no adult branding or
          product details. Your privacy is fully protected from checkout to
          delivery.
        </p>

        <h5>Order Sex Toys in {cityData.city} Today</h5>
        <p>
          Place your order today and enjoy premium adult wellness products with
          fast delivery, secure payments, and complete peace of mind.
        </p>

        <p>
          <strong>LushDesire</strong> – India’s trusted online sex toy store.
        </p>
      </div>
    </>
  );
};

export default MadhyaPradesh;
